var calendarModule = angular.module('calendarModule', [
    'ui.calendar',
    'commons.app',
    'ui.bootstrap'
]);